module.exports = __webpack_public_path__ + "img/1F624.1d82d159.svg";